import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { NgxSpinnerService } from "ngx-spinner";
import { ProductService } from "src/app/components/shared/services/product.service";
import { constApi } from "src/environments/constApi";

@Component({
  selector: "app-product-select-dialog",
  templateUrl: "./product-select-dialog.component.html",
  styleUrls: ["./product-select-dialog.component.sass"],
})
export class ProductSelectDialogComponent implements OnInit {
  itemArray: any[] = [];
  ram: any[] = [];
  disco: any[] = [];
  monitor: any[] = [];
  fbDinamico: FormGroup;
  DenoCat: any = "";
  Codigo: any = "";
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private productService: ProductService,
    public dialogRef: MatDialogRef<ProductSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public product: any
  ) {}
  async ngOnInit(): Promise<void> {
    this.buildForm();
    this.Codigo = ''
    switch (this.product) {
      case 0:
        this.Codigo = "AAC22";
        break;
      case 1:
        this.Codigo = "AAC05";
        break;
      case 2:
        this.Codigo = "AAC06";
        break;
      case 3:
        this.Codigo = "AEQ16";
        break;
    }
    if(this.Codigo.length > 0){
      let param1 = [{ clave: "Codigo", valor: this.Codigo }];
      let resItem: any = await this.obtenerProductos(param1);
      if (resItem.body.length > 0) {
        this.DenoCat = resItem.body[0].DenoCat;
        this.itemArray = resItem.body;
      }
    }
    this.spinner.hide();
  }
  buildForm() {
    this.fbDinamico = this.fb.group({
      item: [""],
    });
  }
  async obtenerProductos(param) {
    return await this.productService
      .getParam(constApi.ITEMSEC_LIST, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  public close(): void {
    this.dialogRef.close();
  }
  enviarDatosProforma(i) {
    this.dialogRef.close(this.itemArray[i]);
  }
  enviarDatosProformaBtn() {
    let index = this.itemArray.findIndex(x => x.idItem == this.fbDinamico.get("item").value)
    this.dialogRef.close(this.itemArray[index]);
  }
}
